import React from "react";
import { PAYMENT_CHANELS, PageName } from "../../../constants/common";
const PaymentGuild: React.FC<{ channelType: string }> = ({ channelType }) => {
  if (channelType === PageName.SHOPEE) {
    return (
      <div className="payment-guid shoppe">
        <div className="content-qrstep">
          <p className="title">Hướng dẫn thanh toán bằng Shoppe Pay</p>
          <p className="step">
            <span className="number">01</span>
            Mở ứng dụng và đăng nhập Shopee Pay
          </p>
          <p className="step">
            <span className="number">02</span>
            Chọn icon thanh toán (mã QR) ở góc chính giữa phía dưới màn hình để
            quét QR Code
          </p>
          <p className="step">
            <span className="number">03</span>
            Bấm chọn “Xác nhận” để thanh toán
          </p>
        </div>
      </div>
    );
  }

  if (channelType === PageName.VNPAY) {
    return (
      <div className="payment-guid vnp">
        <div className="content-qrstep">
          <p className="title">Hướng dẫn thanh toán bằng VNPay</p>
          <p className="step">
            <span className="number">01</span>
            Đăng nhập ứng dụng VNPay
          </p>
          <p className="step">
            <span className="number">02</span>
            Chọn chức năng QRPAY và quét mã QR.
          </p>
          <p className="step">
            <span className="number">03</span>
            Xác nhận thanh toán và hoàn tất giao dịch
          </p>
        </div>
      </div>
    );
  }
  if (channelType === PageName.ZALO) {
    return (
      <div className="payment-guid zalo">
        <div className="content-qrstep">
          <p className="title">Hướng dẫn thanh toán bằng Zalo Pay</p>
          <p className="step">
            <span className="number">01</span>
            Mở ứng dụng và đăng nhập Zalo Pay
          </p>
          <p className="step">
            <span className="number">02</span>
            Chọn icon thanh toán (mã QR) ở góc chính giữa phía dưới màn hình để
            quét QR Code.
          </p>
          <p className="step">
            <span className="number">03</span>
            Bấm chọn “Xác nhận” để thanh toán
          </p>
        </div>
      </div>
    );
  }
  return <></>;
};
export default PaymentGuild;
